var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorporatePlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 79,
    viewBox: "0 0 78 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.3969,
    height: 26.2424,
    rx: 0.950116,
    transform: "matrix(0.707103 -0.70711 0.707103 0.70711 50.2343 29.9431)",
    stroke: "white",
    strokeWidth: 2.85035
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.8504,
    height: 15.1279,
    rx: 3.4252,
    transform: "matrix(-0.707103 -0.70711 -0.707103 0.70711 30.0894 60.542)",
    stroke: "white",
    strokeWidth: 2.85035
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.67911,
    height: 11.3135,
    rx: 3.33956,
    transform: "matrix(-0.707103 -0.70711 -0.707103 0.70711 24.0963 56.8414)",
    stroke: "white",
    strokeWidth: 2.85035
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6.8504,
    height: 11.56,
    rx: 3.4252,
    transform: "matrix(-0.707103 -0.70711 -0.707103 0.70711 33.4731 66.9129)",
    stroke: "white",
    strokeWidth: 2.85035
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6.8504,
    height: 9.04823,
    rx: 3.4252,
    transform: "matrix(-0.707103 -0.70711 -0.707103 0.70711 37.3833 72.6019)",
    stroke: "white",
    strokeWidth: 2.85035
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 11.3969,
    height: 26.2424,
    rx: 0.950116,
    transform: "matrix(-0.707103 -0.70711 -0.707103 0.70711 27.7659 29.9431)",
    stroke: "white",
    strokeWidth: 2.85035
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4539 33.1689L50.6792 35.6717C49.9753 36.3065 49.0241 36.5928 48.0867 36.4517L43.0928 35.7003C40.7764 35.3517 38.4245 36.0468 36.6697 37.5986L33.0464 40.8027C31.3901 42.2674 30.9632 44.6811 32.0168 46.625L35.0272 52.1795C35.3149 52.7104 35.9775 52.9181 36.4864 52.5929C38.5853 51.2515 40.9896 48.7641 39.1874 45.3226C39.1533 45.2574 39.166 45.1749 39.2209 45.1259C40.5887 43.9061 41.7572 42.9515 43.0542 41.8033C43.117 41.7478 43.2123 41.7505 43.2715 41.8098L60.3887 58.9271",
    stroke: "white",
    strokeWidth: 2.85035
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5971 64.0333L56.5668 62.9889L55.5971 64.0333ZM49.1365 55.7096C48.58 55.153 47.6776 55.153 47.121 55.7096C46.5645 56.2662 46.5645 57.1685 47.121 57.7251L49.1365 55.7096ZM59.3024 59.847C59.8337 60.391 59.9606 60.9037 59.9303 61.3305C59.8973 61.7953 59.6647 62.2931 59.2578 62.707C58.3993 63.5805 57.3085 63.6776 56.5668 62.9889L54.6273 65.0776C56.8577 67.1488 59.7297 66.2933 61.2907 64.705C62.0937 63.888 62.685 62.7776 62.7735 61.5324C62.8646 60.2491 62.4104 58.9498 61.3414 57.8553L59.3024 59.847ZM56.5668 62.9889C54.4569 61.0297 51.1256 57.6986 49.1365 55.7096L47.121 57.7251C49.0948 59.6989 52.4696 63.0741 54.6273 65.0776L56.5668 62.9889Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9574 68.529L50.9272 67.4847L49.9574 68.529ZM43.4969 60.2053C42.9403 59.6488 42.038 59.6488 41.4814 60.2053C40.9248 60.7619 40.9248 61.6643 41.4814 62.2208L43.4969 60.2053ZM53.6627 64.3427C54.1941 64.8868 54.321 65.3994 54.2906 65.8262C54.2576 66.291 54.025 66.7888 53.6182 67.2027C52.7597 68.0762 51.6688 68.1733 50.9272 67.4847L48.9877 69.5734C51.2181 71.6445 54.09 70.789 55.651 69.2007C56.454 68.3838 57.0454 67.2733 57.1338 66.0281C57.225 64.7448 56.7708 63.4455 55.7018 62.3511L53.6627 64.3427ZM50.9272 67.4847C48.8173 65.5254 45.4859 62.1944 43.4969 60.2053L41.4814 62.2208C43.4551 64.1946 46.83 67.5698 48.9877 69.5734L50.9272 67.4847Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0078 72.4919L44.9775 71.4476L44.0078 72.4919ZM38.2331 65.0065C37.6765 64.45 36.7742 64.45 36.2176 65.0065C35.661 65.5631 35.661 66.4655 36.2176 67.022L38.2331 65.0065ZM47.7131 68.3056C48.2444 68.8497 48.3713 69.3623 48.341 69.7891C48.308 70.254 48.0754 70.7517 47.6685 71.1657C46.81 72.0392 45.7192 72.1363 44.9775 71.4476L43.038 73.5363C45.2684 75.6074 48.1403 74.7519 49.7014 73.1636C50.5044 72.3467 51.0957 71.2363 51.1842 69.991C51.2753 68.7077 50.8211 67.4084 49.7521 66.314L47.7131 68.3056ZM44.9775 71.4476C42.8464 69.4687 40.195 66.9685 38.2331 65.0065L36.2176 67.022C38.2184 69.0229 40.9015 71.5524 43.038 73.5363L44.9775 71.4476Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6506 70.2821C44.8513 73.559 40.2026 79.1222 35.7064 75.007",
    stroke: "white",
    strokeWidth: 2.85035
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6064 45.8957L15.5202 48.6952C16.1417 49.2923 16.493 50.117 16.493 50.9789V55.4216M24.7234 33.6262L26.9249 35.7277C27.6494 36.4193 28.6584 36.7274 29.6457 36.5585L32.8966 36.0024C33.5375 35.8928 34.1941 35.9159 34.8257 36.0703L37.2975 36.6745",
    stroke: "white",
    strokeWidth: 2.85035
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6064 45.8957L15.5202 48.6952C16.1417 49.2923 16.493 50.117 16.493 50.9789V55.4216M24.7234 33.6262L26.9249 35.7277C27.6494 36.4193 28.6584 36.7274 29.6457 36.5585L32.8966 36.0024C33.5375 35.8928 34.1941 35.9159 34.8257 36.0703L37.2975 36.6745",
    stroke: "white",
    strokeWidth: 2.85035
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0444 45.8196L62.1005 48.5371C61.451 49.1366 61.0816 49.9803 61.0816 50.8642V53.2599C61.0816 53.73 60.977 54.1942 60.7753 54.6188L59.6337 57.0222",
    stroke: "white",
    strokeWidth: 2.85035
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3684 20.7471V2",
    stroke: "white",
    strokeWidth: 2.85035,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4688 23.4144L56.2047 11.8309",
    stroke: "white",
    strokeWidth: 2.85035,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2679 23.2617L20.532 11.6781",
    stroke: "white",
    strokeWidth: 2.85035,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporatePlanning);
export default __webpack_public_path__ + "static/media/Corporate-Planning.a12263cca4539662412ee95b7c4793fe.svg";
export { ForwardRef as ReactComponent };